import React, { useState } from 'react'
import { toast } from 'react-toastify'
import PhoneInput from 'react-phone-input-2'

const QuestionsForm = () => {
  const [progress, setProgress] = useState(0)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [address, setAddress] = useState('')
  const [sellOption, setSellOption] = useState('')
  const [errors, setErrors] = useState({
    address: '',
    sellOption: '',
    name: '',
    phone: '',
    email: ''
  })

  // const HandelAddress = () => {
  //   if (!address) {
  //     setErrors({ address: 'Address is required' })
  //   } else {
  //     setProgress(38)
  //   }
  // }

  // const HandelSellOption = () => {
  //   if (!sellOption) {
  //     setErrors({ sellOption: 'Timeline to sell is required' })
  //   } else {
  //     setProgress(63)
  //   }
  // }
  // const HandelName = () => {
  //   if (!name) {
  //     setErrors({ name: 'Name is required' })
  //   } else {
  //     setProgress(88)
  //   }
  // }
  // const HandelPhone = () => {
  //   if (!phone) {
  //     setErrors({ phone: 'Phone Number is required' })
  //   } else {
  //     setProgress(100)
  //   }
  // }
  // const HandleQuestionsSubmit = () => {
  //   if (!email) {
  //     setErrors({ email: 'Ema Number is required' })
  //   } else {
  //     toast.success(
  //       'Thank you! Your submission has been successfully received.'
  //     )
  //     setProgress(0)
  //   }
  // }
  const validatePhoneNumber = phone => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/ // Allows numbers with an optional leading '+'
    return phoneRegex.test(phone)
  }

  const validateEmail = email => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return emailRegex.test(email)
  }

  const validateName = name => {
    const nameRegex = /^[a-zA-Z\s]+$/ // Allows only letters and spaces
    return nameRegex.test(name)
  }

  const HandelAddress = () => {
    if (!address) {
      setErrors(prevErrors => ({
        ...prevErrors,
        address: 'Address is required'
      }))
    } else {
      setProgress(38)
      setErrors(prevErrors => ({ ...prevErrors, address: '' }))
    }
  }

  const HandelSellOption = () => {
    if (!sellOption) {
      setErrors(prevErrors => ({
        ...prevErrors,
        sellOption: 'Timeline to sell is required'
      }))
    } else {
      setProgress(63)
      setErrors(prevErrors => ({ ...prevErrors, sellOption: '' }))
    }
  }

  const HandelName = () => {
    if (!name) {
      setErrors(prevErrors => ({ ...prevErrors, name: 'Name is required' }))
    } else if (!validateName(name)) {
      setErrors(prevErrors => ({
        ...prevErrors,
        name: 'Name should only contain letters'
      }))
    } else {
      setProgress(88)
      setErrors(prevErrors => ({ ...prevErrors, name: '' }))
    }
  }

  const HandelPhone = () => {
    if (!phone) {
      setErrors(prevErrors => ({
        ...prevErrors,
        phone: 'Phone number is required'
      }))
    } else if (!validatePhoneNumber(phone)) {
      setErrors(prevErrors => ({
        ...prevErrors,
        phone: 'Invalid phone number (10-15 digits required)'
      }))
    } else {
      setProgress(100)
      setErrors(prevErrors => ({ ...prevErrors, phone: '' }))
    }
  }

  const HandleQuestionsSubmit = () => {
    if (!email) {
      setErrors(prevErrors => ({ ...prevErrors, email: 'Email is required' }))
    } else if (!validateEmail(email)) {
      setErrors(prevErrors => ({
        ...prevErrors,
        email: 'Invalid email format'
      }))
    } else {
      toast.success(
        'Thank you! Your submission has been successfully received.'
      )
      setName('')
      setEmail('')
      setPhone('')
      setAddress('')
      setSellOption('')
      setProgress(0)
      setErrors({})
    }
  }

  return (
    <div>
      <form id='msform'>
        {progress === 0 && (
          <fieldset>
            <div className='form-card'>
              <div className='card_body'>
                <label>Enter your full address</label>
                <textarea
                  placeholder='Enter your full address'
                  className='form-control'
                  required
                  value={address}
                  onChange={e => setAddress(e.target.value)}
                ></textarea>
                {errors.address && (
                  <p className='text-danger'>{errors.address}</p>
                )}
              </div>
              <div className='card_footer text-md-right'>
                <input
                  type='button'
                  name='next'
                  className='bg-dark next'
                  value='Next'
                  onClick={() => HandelAddress()}
                />
              </div>
            </div>
          </fieldset>
        )}

        {progress === 38 && (
          <fieldset>
            <div className='form-card'>
              <div className='card_body'>
                <label>Timeline to sell? *</label>
                <div className='rdo_boxs'>
                  <input
                    type='radio'
                    name='sell'
                    id='onemonth'
                    value='1 Month'
                    onChange={() => setSellOption('1 Month')}
                  />
                  <label htmlFor='onemonth'>1 Month</label>
                </div>
                <div className='rdo_boxs'>
                  <input
                    type='radio'
                    name='sell'
                    id='1_3months'
                    value='2 Months'
                    onChange={() => setSellOption('2 Months')}
                  />
                  <label htmlFor='1_3months'>2 Months</label>
                </div>
                <div className='rdo_boxs'>
                  <input
                    type='radio'
                    name='sell'
                    id='3_6months'
                    value='3 Months or more+'
                    onChange={() => setSellOption('3 Months or more+')}
                  />
                  <label htmlFor='3_6months'>3 Months or more+</label>
                </div>
                {errors.sellOption && (
                  <p className='text-danger'>{errors.sellOption}</p>
                )}
              </div>
              <div className='card_footer text-md-right'>
                <input
                  type='button'
                  name='next'
                  className='bg-dark next'
                  value='Next'
                  onClick={() => HandelSellOption()}
                />
              </div>
            </div>
          </fieldset>
        )}

        {progress === 63 && (
          <fieldset>
            <div className='form-card'>
              <div className='card_body'>
                <label>What is your Name? *</label>
                <input
                  placeholder='Name'
                  className='form-control'
                  required
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
                {errors.name && <p className='text-danger'>{errors.name}</p>}
              </div>
              <div className='card_footer text-md-right'>
                <input
                  type='button'
                  name='next'
                  className='bg-dark next'
                  value='Next'
                  onClick={() => HandelName()}
                />
              </div>
            </div>
          </fieldset>
        )}

        {progress === 88 && (
          <fieldset>
            <div className='form-card'>
              <div className='card_body' style={{ marginBottom: '20px' }}>
                <label>What is your phone number? *</label>

                <PhoneInput
                  country={'ca'}
                  className='PhoneInput'
                  placeholder='Phone Number'
                  value={phone}
                  onChange={setPhone}
                />
                {errors.phone && <p className='text-danger'>{errors.phone}</p>}
              </div>
              <div className='card_footer text-md-right'>
                <input
                  type='button'
                  name='next'
                  className='bg-dark next'
                  value='Next'
                  onClick={() => HandelPhone()}
                />
              </div>
            </div>
          </fieldset>
        )}

        {progress === 100 && (
          <fieldset>
            <div className='form-card'>
              <div className='card_body'>
                <label>What is your email? *</label>
                <input
                  type='email'
                  placeholder='We will send you updated market analysis'
                  className='form-control'
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
                {errors.email && <p className='text-danger'>{errors.email}</p>}
              </div>
              <div className='card_footer text-md-right'>
                <input
                  type='button'
                  name='Submit'
                  className='bg-dark next'
                  value='Submit'
                  onClick={HandleQuestionsSubmit}
                />
              </div>
            </div>
          </fieldset>
        )}

        <div className='progress'>
          <div
            className='progress-bar progress-bar-striped progress-bar-animated'
            role='progressbar'
            aria-valuemin='0'
            aria-valuemax='100'
            style={{ width: `${progress}%` }}
          >
            {progress}%
          </div>
        </div>
      </form>
    </div>
  )
}

export default QuestionsForm
